export const sortCategoryLabelsAlphabetically = (categoryLabels: string[]) =>
	categoryLabels.sort((a, b) => a.localeCompare(b));
